import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
    static classes = ["scrolled"]
    static values = { threshold: { type: Number, default: 10 } }

    declare readonly scrolledClass: string
    declare readonly thresholdValue: number

    connect(): void {
        this.onScroll()
        window.addEventListener("scroll", this.onScroll.bind(this))
    }

    disconnect(): void {
        window.removeEventListener("scroll", this.onScroll.bind(this))
    }

    onScroll(): void {
        const classes = this.scrolledClass.split(" ")
        if (window.scrollY > this.thresholdValue) {
            this.element.classList.add(...classes)
        } else {
            this.element.classList.remove(...classes)
        }
    }
}
